import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';

import css from './SecurePaymentBadge.module.css';

// ShieldCheck icon from Lucide (ISC license), vendored inline per the template's Icon* convention.
const IconShieldCheck = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);

/**
 * "Sichere Zahlung" trust badge: payment is processed through the platform
 * (Stripe) and only released to the provider once the booking is confirmed.
 * True by construction of the transaction process — no data dependencies.
 *
 * @param {Object} props
 * @param {string?} props.className
 * @param {string?} props.rootClassName
 */
const SecurePaymentBadge = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <span className={css.icon} aria-hidden="true">
        <IconShieldCheck />
      </span>
      <div>
        <p className={css.title}>
          <FormattedMessage id="SecurePaymentBadge.title" />
        </p>
        <p className={css.text}>
          <FormattedMessage id="SecurePaymentBadge.text" />
        </p>
      </div>
    </div>
  );
};

export default SecurePaymentBadge;
